import { useState, useEffect, useRef } from "react";

/* ── Supabase ── */
const SUPABASE_URL = "https://ubdoalwycxovzagznndt.supabase.co";
const SUPABASE_KEY = "sb_publishable_BjBSnHQxvK9y8N7Y7ejc0w_OcooLWDF";

async function sb(path, options = {}) {
  const res = await fetch(`${SUPABASE_URL}/rest/v1/${path}`, {
    headers: {
      "apikey": SUPABASE_KEY,
      "Authorization": `Bearer ${SUPABASE_KEY}`,
      "Content-Type": "application/json",
      "Prefer": options.prefer || "return=representation",
      ...options.headers,
    },
    ...options,
  });
  if (!res.ok) {
    const err = await res.text();
    throw new Error(err);
  }
  const text = await res.text();
  return text ? JSON.parse(text) : [];
}

const api = {
  // Randevular
  getApts:    ()        => sb("appointments?select=*&order=date.asc,start_time.asc"),
  addApt:     (data)    => sb("appointments", { method:"POST", body: JSON.stringify(dbApt(data)) }),
  updateApt:  (id,data) => sb(`appointments?id=eq.${id}`, { method:"PATCH", body: JSON.stringify(dbApt(data)), prefer:"return=representation" }),
  deleteApt:  (id)      => sb(`appointments?id=eq.${id}`, { method:"DELETE", prefer:"return=minimal" }),
  // Kategoriler
  getCats:    ()        => sb("categories?select=*&order=created_at.asc"),
  addCat:     (data)    => sb("categories", { method:"POST", body: JSON.stringify(data) }),
  deleteCat:  (id)      => sb(`categories?id=eq.${id}`, { method:"DELETE", prefer:"return=minimal" }),
  // Ayarlar
  getSett:    ()        => sb("settings?select=*"),
  setSett:    (key,val) => sb("settings", { method:"POST", body: JSON.stringify({key,value:val}), headers:{"Prefer":"resolution=merge-duplicates,return=minimal"} }),
};

// JS → DB kolon adı dönüşümü
function dbApt(d) {
  // Temel kolonlar (mevcut Supabase tablosunda var)
  const base = {
    id:          d.id,
    client_name: d.clientName,
    phone:       d.phone || null,
    category_id: (d.categoryIds && d.categoryIds[0]) || d.categoryId || null,
    date:        d.date,
    start_time:  d.startTime,
    end_time:    d.endTime || null,
    note:        d.note || null,
    status:      d.status || "pending",
    price:       d.price ? Number(d.price) : 0,
  };
  // Yeni kolonlar - migration çalıştırıldıktan sonra aktif olur
  try {
    base.category_ids = JSON.stringify(d.categoryIds || (d.categoryId ? [d.categoryId] : []));
    base.staff_id     = d.staffId || null;
    base.payment_type = d.paymentType || null;
  } catch {}
  return base;
}
// DB → JS
function jsApt(d) {
  let categoryIds = [];
  try { categoryIds = JSON.parse(d.category_ids || "[]"); } catch { categoryIds = d.category_ids ? [d.category_ids] : []; }
  return {
    id:          d.id,
    clientName:  d.client_name,
    phone:       d.phone || "",
    categoryIds: categoryIds,
    categoryId:  categoryIds[0] || d.category_id || "",
    date:        d.date,
    startTime:   d.start_time,
    endTime:     d.end_time || "",
    note:        d.note || "",
    status:      d.status || "pending",
    price:       d.price || 0,
    staffId:     d.staff_id || null,
    paymentType: d.payment_type || null,
  };
}
function jsCat(d) {
  return { id:d.id, name:d.name, color:d.color, icon:d.icon };
}

/* ── Sabitler ── */
const SEK       = "kib_ses_v7";

/* ── Supabase Auth ── */
const auth = {
  signIn: async (email, password) => {
    const r = await fetch(`${SUPABASE_URL}/auth/v1/token?grant_type=password`, {
      method: "POST",
      headers: { "apikey": SUPABASE_KEY, "Content-Type": "application/json" },
      body: JSON.stringify({ email, password }),
    });
    const data = await r.json();
    if (!r.ok) throw new Error(data.error_description || data.msg || "Giriş başarısız");
    return data; // { access_token, refresh_token, user }
  },
  signOut: async (token) => {
    await fetch(`${SUPABASE_URL}/auth/v1/logout`, {
      method: "POST",
      headers: { "apikey": SUPABASE_KEY, "Authorization": `Bearer ${token}` },
    });
  },
  resetPassword: async (email) => {
    const r = await fetch(`${SUPABASE_URL}/auth/v1/recover`, {
      method: "POST",
      headers: { "apikey": SUPABASE_KEY, "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    });
    return r.ok;
  },
  updatePassword: async (token, password) => {
    const r = await fetch(`${SUPABASE_URL}/auth/v1/user`, {
      method: "PUT",
      headers: { "apikey": SUPABASE_KEY, "Authorization": `Bearer ${token}`, "Content-Type": "application/json" },
      body: JSON.stringify({ password }),
    });
    return r.ok;
  },
};
const PWK       = "kib_pass_v7";
const EPK       = "kib_email_v7";
const DEF_EMAIL = "kibele@kibele.com";
const DEF_PASS  = "kibele2024";
const SLOT_H    = 54;
const DAY_START = 8 * 60;

const DEF_CATS = [
  { id:"cilt",   name:"Cilt Bakımı & Maske",      color:"#c9806e", icon:"✨" },
  { id:"makyaj", name:"Cilt + Makyaj + Epilasyon", color:"#9b6ea8", icon:"💄" },
];

const TR_S = ["Pzt","Sal","Çar","Per","Cum","Cmt","Paz"];
const TR_F = ["Pazartesi","Salı","Çarşamba","Perşembe","Cuma","Cumartesi","Pazar"];
const TR_M = ["Ocak","Şubat","Mart","Nisan","Mayıs","Haziran","Temmuz","Ağustos","Eylül","Ekim","Kasım","Aralık"];

const STC = {
  pending:   { label:"Bekliyor",   color:"#f0a030", bg:"#fff8ee", icon:"⏳" },
  done:      { label:"Tamamlandı", color:"#3aaa6e", bg:"#edfbf3", icon:"✅" },
  cancelled: { label:"İptal",      color:"#e05555", bg:"#fdf0f0", icon:"❌" },
};

function toMins(t) {
  if (!t||!t.includes(":")) return 0;
  const [h,m]=t.split(":").map(Number); return h*60+m;
}
function toTime(m) { return `${String(Math.floor(m/60)).padStart(2,"0")}:${m%60===0?"00":"30"}`; }
function dateStr(d) { return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}`; }
function sameDay(a,b) { return a.getFullYear()===b.getFullYear()&&a.getMonth()===b.getMonth()&&a.getDate()===b.getDate(); }
function addDays(d,n) { return new Date(d.getFullYear(),d.getMonth(),d.getDate()+n); }
function weekDays(base) {
  const diff=(base.getDay()+6)%7;
  const mon=new Date(base.getFullYear(),base.getMonth(),base.getDate()-diff);
  return Array.from({length:7},(_,i)=>new Date(mon.getFullYear(),mon.getMonth(),mon.getDate()+i));
}
function geo(s,e) {
  const sm=toMins(s),em=e?toMins(e):sm+30;
  return {top:((sm-DAY_START)/30)*SLOT_H,height:((em-sm)/30)*SLOT_H};
}
function fmtTL(n) { if(!n)return ""; return Number(n).toLocaleString("tr-TR")+" ₺"; }

const SLOTS=(()=>{const r=[];for(let h=8;h<=21;h++){r.push(`${String(h).padStart(2,"0")}:00`);if(h<21)r.push(`${String(h).padStart(2,"0")}:30`);}return r;})();

async function sendEmail({svcId,tplId,pubKey,toEmail,subject,body}) {
  if(!svcId||!tplId||!pubKey||!toEmail) return false;
  try {
    const r=await fetch("https://api.emailjs.com/api/v1.0/email/send",{
      method:"POST",headers:{"Content-Type":"application/json"},
      body:JSON.stringify({service_id:svcId,template_id:tplId,user_id:pubKey,
        template_params:{to_email:toEmail,subject,message:body}}),
    });
    return r.ok;
  } catch { return false; }
}

/* ══ GİRİŞ EKRANI ══ */
function LoginScreen({onLogin}) {
  const [email,setEmail]=useState("");
  const [pass,setPass]=useState("");
  const [show,setShow]=useState(false);
  const [err,setErr]=useState("");
  const [busy,setBusy]=useState(false);

  const [reset,setReset]=useState(false);
  const [resetOk,setResetOk]=useState(false);

  async function doLogin() {
    if(!email.trim()||!pass){setErr("E-posta ve şifre gerekli");return;}
    setBusy(true);setErr("");
    try {
      const data=await auth.signIn(email.trim(),pass);
      localStorage.setItem(SEK,data.access_token);
      localStorage.setItem("kib_refresh",data.refresh_token||"");
      onLogin(data.access_token);
    } catch(e) {
      setErr(e.message||"E-posta veya şifre hatalı");
      setBusy(false);
    }
  }

  async function doReset() {
    if(!email.trim()){setErr("E-posta adresinizi girin");return;}
    setBusy(true);setErr("");
    const ok=await auth.resetPassword(email.trim());
    setBusy(false);
    if(ok) setResetOk(true);
    else setErr("E-posta gönderilemedi");
  }

  const inp={width:"100%",padding:"14px 16px",borderRadius:14,fontSize:15,
    fontFamily:"'Nunito',sans-serif",border:"1px solid rgba(255,255,255,.2)",
    background:"rgba(255,255,255,.12)",color:"#fff",outline:"none",marginTop:6};

  return (
    <div style={{minHeight:"100vh",background:"linear-gradient(160deg,#2a1a1a 0%,#4a2a22 55%,#8a4a3a 100%)",
      display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",
      fontFamily:"'Nunito',sans-serif",padding:28}}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700&family=Playfair+Display:ital,wght@0,600;1,400&display=swap');
        *{box-sizing:border-box;margin:0;padding:0}
        .li::placeholder{color:rgba(255,255,255,.4)!important}
        .li:focus{border-color:rgba(201,128,110,.8)!important;background:rgba(255,255,255,.18)!important}
        .lbtn{transition:all .15s;cursor:pointer;border:none;font-family:'Nunito',sans-serif}
        .lbtn:hover{opacity:.9;transform:translateY(-1px)}.lbtn:active{transform:scale(.97)}
      `}</style>
      <div style={{width:"100%",maxWidth:360}}>
        <div style={{textAlign:"center",marginBottom:44}}>
          <div style={{fontFamily:"'Playfair Display',serif",fontSize:42,fontWeight:600,color:"#fff",letterSpacing:"-1px"}}>Kibele</div>
          <div style={{fontFamily:"'Playfair Display',serif",fontSize:18,fontStyle:"italic",color:"rgba(255,255,255,.5)",marginTop:4}}>Beauty</div>
          <div style={{width:40,height:2,background:"rgba(201,128,110,.6)",margin:"16px auto 0",borderRadius:2}}/>
        </div>
        <div style={{display:"flex",flexDirection:"column",gap:14}}>
          <div>
            <label style={{fontSize:11,color:"rgba(255,255,255,.5)",fontWeight:700,letterSpacing:.8,textTransform:"uppercase"}}>E-posta</label>
            <input className="li" style={inp} type="email" inputMode="email" value={email}
              onChange={e=>{setEmail(e.target.value);setErr("");}} placeholder="ornek@email.com"
              onKeyDown={e=>e.key==="Enter"&&doLogin()}/>
          </div>
          <div style={{position:"relative"}}>
            <label style={{fontSize:11,color:"rgba(255,255,255,.5)",fontWeight:700,letterSpacing:.8,textTransform:"uppercase"}}>Şifre</label>
            <input className="li" style={{...inp,paddingRight:48}} type={show?"text":"password"} value={pass}
              onChange={e=>{setPass(e.target.value);setErr("");}} placeholder="••••••••"
              onKeyDown={e=>e.key==="Enter"&&doLogin()}/>
            <button onClick={()=>setShow(s=>!s)} style={{position:"absolute",right:14,bottom:14,background:"transparent",border:"none",cursor:"pointer",fontSize:18,color:"rgba(255,255,255,.5)"}}>
              {show?"🙈":"👁"}
            </button>
          </div>
          {err&&<div style={{background:"rgba(224,85,85,.2)",border:"1px solid rgba(224,85,85,.4)",borderRadius:10,padding:"10px 14px",fontSize:13,color:"#ffaaaa",textAlign:"center",fontWeight:600}}>{err}</div>}
          <button className="lbtn" onClick={doLogin} disabled={busy}
            style={{marginTop:4,padding:"16px",borderRadius:14,background:"#c9806e",color:"#fff",fontSize:15,fontWeight:700,opacity:busy?.7:1,boxShadow:"0 6px 20px rgba(201,128,110,.4)"}}>
            {busy?"Giriş yapılıyor...":"Giriş Yap"}
          </button>
        </div>
        {!reset?(
          <button onClick={()=>{setReset(true);setErr("");}} style={{display:"block",margin:"16px auto 0",background:"transparent",border:"none",color:"rgba(255,255,255,.4)",fontSize:13,cursor:"pointer",fontFamily:"'Nunito',sans-serif"}}>Şifremi Unuttum</button>
        ):resetOk?(
          <div style={{textAlign:"center",marginTop:16,fontSize:13,color:"rgba(255,255,255,.7)",background:"rgba(255,255,255,.1)",borderRadius:10,padding:"10px 14px"}}>✅ Şifre sıfırlama linki e-postanıza gönderildi!</div>
        ):(
          <div style={{marginTop:16,display:"flex",flexDirection:"column",gap:8}}>
            <button onClick={doReset} disabled={busy} style={{padding:"12px",borderRadius:12,background:"rgba(255,255,255,.15)",border:"1px solid rgba(255,255,255,.2)",color:"#fff",fontSize:13,fontWeight:700,cursor:"pointer",fontFamily:"'Nunito',sans-serif"}}>{busy?"Gönderiliyor...":"📧 Sıfırlama Linki Gönder"}</button>
            <button onClick={()=>{setReset(false);setErr("");}} style={{padding:"8px",borderRadius:12,background:"transparent",border:"none",color:"rgba(255,255,255,.4)",fontSize:12,cursor:"pointer",fontFamily:"'Nunito',sans-serif"}}>← Geri Dön</button>
          </div>
        )}
        <div style={{textAlign:"center",marginTop:16,fontSize:12,color:"rgba(255,255,255,.2)"}}>Kibele Beauty · Randevu Sistemi</div>
      </div>
    </div>
  );
}

/* ══ ANA UYGULAMA ══ */
export default function App() {
  const [token,setToken]=useState(null);
  useEffect(()=>{
    try {
      const t=localStorage.getItem(SEK);
      if(t&&t.length>20) setToken(t);
    } catch {}
  },[]);
  async function doLogout(){
    try{
      const t=localStorage.getItem(SEK);
      if(t) await auth.signOut(t);
    } catch{}
    localStorage.removeItem(SEK);
    localStorage.removeItem("kib_refresh");
    setToken(null);
  }
  if(!token) return <LoginScreen onLogin={(t)=>setToken(t)}/>;
  return <MainApp onLogout={doLogout} authToken={token}/>;
}

/* ══ MAIN APP ══ */
function MainApp({onLogout,authToken}) {
  const NOW=new Date();
  const C="#c9806e";

  const [weekBase, setWeekBase] = useState(new Date(NOW.getFullYear(),NOW.getMonth(),NOW.getDate()));
  const [selDay,   setSelDay]   = useState(new Date(NOW.getFullYear(),NOW.getMonth(),NOW.getDate()));
  const [view,     setView]     = useState("day");
  const [apts,     setApts]     = useState([]);
  const [cats,     setCats]     = useState(DEF_CATS);
  const [staff,    setStaff]    = useState([]);
  const [modal,    setModal]    = useState(null);
  const [sett,     setSett]     = useState({toEmail:"",svcId:"",tplId:"",pubKey:""});
  const [showSett, setShowSett] = useState(false);
  const [mailSt,   setMailSt]   = useState(null);
  const [alertMsg, setAlertMsg] = useState(null);
  const [selecting,setSelecting]= useState(null);
  const [search,   setSearch]   = useState("");
  const [showSrch, setShowSrch] = useState(false);
  const [loading,  setLoading]  = useState(true);
  const [toast,    setToast]    = useState(null);
  const sentRef=useRef(false);

  function showToast(msg,type="ok") {
    setToast({msg,type});
    setTimeout(()=>setToast(null),3000);
  }

  /* ── Supabase'den yükle ── */
  useEffect(()=>{
    async function load() {
      try {
        const [dbApts,dbCats,dbSett]=await Promise.all([api.getApts(),api.getCats(),api.getSett()]);
        setApts(dbApts.map(jsApt));
        if(dbCats.length>0) setCats(dbCats.map(jsCat));
        // Staff localStorage'dan yükle (Supabase tablosu sonradan eklenecek)
        try { const sf=localStorage.getItem("kib_staff_v7"); if(sf) setStaff(JSON.parse(sf)); } catch{}
        const settObj={toEmail:"",svcId:"",tplId:"",pubKey:""};
        dbSett.forEach(s=>{if(s.key in settObj) settObj[s.key]=s.value||"";});
        setSett(settObj);
      } catch(e) {
        console.error("Yükleme hatası:",e);
        showToast("Bağlantı hatası — veriler yüklenemedi","error");
      } finally { setLoading(false); }
    }
    load();
  },[]);

  /* ── 20:00 e-posta ── */
  useEffect(()=>{
    const check=()=>{
      const now=new Date();
      if(now.getHours()!==20||now.getMinutes()>=2){sentRef.current=false;return;}
      if(sentRef.current) return;
      sentRef.current=true;
      const tmr=addDays(now,1),tmrStr=dateStr(tmr);
      const list=apts.filter(a=>a.date===tmrStr&&a.status!=="cancelled").sort((a,b)=>toMins(a.startTime)-toMins(b.startTime));
      setAlertMsg({label:`${tmr.getDate()} ${TR_M[tmr.getMonth()]}`,list});
      if(sett.svcId&&sett.tplId&&sett.pubKey&&sett.toEmail){
        setMailSt("sending");
        const lbl=`${tmr.getDate()} ${TR_M[tmr.getMonth()]}`;
        const lines=list.length===0?"Yarın randevu yok.":list.map(a=>{const cat=cats.find(c=>c.id===a.categoryId);return `• ${a.startTime}${a.endTime?` – ${a.endTime}`:""} | ${a.clientName} | ${cat?.name||""}${a.price?` | ${fmtTL(a.price)}`:""}`; }).join("\n");
        sendEmail({svcId:sett.svcId,tplId:sett.tplId,pubKey:sett.pubKey,toEmail:sett.toEmail,
          subject:`📅 Yarınki Randevular — ${lbl}`,
          body:`Kibele Beauty — ${lbl}\n\n${lines}\n\nToplam: ${list.length} randevu`})
          .then(ok=>{setMailSt(ok?"ok":"error");setTimeout(()=>setMailSt(null),6000);});
      }
    };
    check();
    const iv=setInterval(check,60000);
    return()=>clearInterval(iv);
  },[apts,cats,sett]);

  /* ── CRUD ── */
  async function saveApt(data) {
    const normalized={
      ...data,
      price:       data.price ? Number(data.price) : 0,
      categoryIds: data.categoryIds||[],
      categoryId:  data.categoryIds?.[0]||data.categoryId||"",
    };
    try {
      if(modal.type==="add") {
        const newApt={...normalized,id:String(Date.now()),status:normalized.status||"pending"};
        await api.addApt(newApt);
        setApts(p=>[...p,newApt]);
        showToast("Randevu eklendi ✅");
      } else {
        await api.updateApt(modal.apt.id,normalized);
        setApts(p=>p.map(a=>a.id===modal.apt.id?{...a,...normalized}:a));
        showToast("Randevu güncellendi ✅");
      }
    } catch { showToast("Kayıt hatası ❌","error"); }
    setModal(null);
  }

  async function delApt(id) {
    try {
      await api.deleteApt(id);
      setApts(p=>p.filter(a=>a.id!==id));
      showToast("Randevu silindi");
    } catch { showToast("Silme hatası ❌","error"); }
    setModal(null);
  }

  async function saveCat(cat) {
    try {
      await api.addCat(cat);
      setCats(p=>[...p,cat]);
      showToast("Kategori eklendi ✅");
    } catch { showToast("Kategori eklenemedi ❌","error"); }
  }

  async function delCat(id) {
    try {
      await api.deleteCat(id);
      setCats(p=>p.filter(c=>c.id!==id));
    } catch { showToast("Kategori silinemedi ❌","error"); }
  }

  async function saveSett(newSett) {
    try {
      await Promise.all(Object.entries(newSett).map(([k,v])=>api.setSett(k,v)));
      setSett(newSett);
      showToast("Ayarlar kaydedildi ✅");
    } catch { showToast("Ayarlar kaydedilemedi ❌","error"); }
  }

  async function testEmail() {
    setMailSt("sending");
    const tmr=addDays(NOW,1),tmrStr=dateStr(tmr);
    const lbl=`${tmr.getDate()} ${TR_M[tmr.getMonth()]}`;
    const list=apts.filter(a=>a.date===tmrStr&&a.status!=="cancelled").sort((a,b)=>toMins(a.startTime)-toMins(b.startTime));
    const lines=list.length===0?"Yarın randevu yok.":list.map(a=>{const cat=cats.find(c=>c.id===a.categoryId);return `• ${a.startTime}${a.endTime?` – ${a.endTime}`:""} | ${a.clientName} | ${cat?.name||""}`;}).join("\n");
    const ok=await sendEmail({svcId:sett.svcId,tplId:sett.tplId,pubKey:sett.pubKey,toEmail:sett.toEmail,subject:`📅 TEST — ${lbl}`,body:`Kibele Beauty — ${lbl}\n\n${lines}\n\nToplam: ${list.length} randevu`});
    setMailSt(ok?"ok":"error");setTimeout(()=>setMailSt(null),5000);
  }

  const days=weekDays(weekBase);
  const dayApts=(day)=>apts.filter(a=>a.date===dateStr(day));
  const srchRes=search.trim().length<2?[]:apts.filter(a=>a.clientName?.toLowerCase().includes(search.toLowerCase())||a.phone?.includes(search)).sort((a,b)=>b.date.localeCompare(a.date)).slice(0,20);

  function handleSlot(day,slot) {
    const ds=dateStr(day);
    if(!selecting){setSelecting({date:ds,start:slot});return;}
    if(selecting.date!==ds){setSelecting({date:ds,start:slot});return;}
    const sm=toMins(selecting.start),cm=toMins(slot);
    if(cm<sm){setSelecting({date:ds,start:slot});return;}
    setModal({type:"add",date:ds,startTime:selecting.start,endTime:toTime(cm+30)});
    setSelecting(null);
  }
  function inSel(day,slot){if(!selecting||dateStr(day)!==selecting.date)return false;return toMins(slot)>=toMins(selecting.start);}

  if(loading) return (
    <div style={{minHeight:"100vh",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",background:"#f8f4f2",fontFamily:"'Nunito',sans-serif"}}>
      <div style={{fontSize:32,marginBottom:16}}>🌸</div>
      <div style={{fontSize:16,color:"#c9806e",fontWeight:700}}>Kibele Beauty</div>
      <div style={{fontSize:13,color:"#bbb",marginTop:8}}>Yükleniyor...</div>
    </div>
  );

  return (
    <div className="app-root" style={{minHeight:"100vh",background:"#f8f4f2",fontFamily:"'Nunito',sans-serif",color:"#2a1a1a"}}>
      <div className="app-inner">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Nunito:wght@400;500;600;700&family=Playfair+Display:ital,wght@0,600;1,400&display=swap');
        *{box-sizing:border-box;margin:0;padding:0}
        .app-root{display:flex;justify-content:center}
        .app-inner{width:100%;max-width:480px}
        @media(min-width:768px){
          .app-root{background:#e8e0dc}
          .app-inner{max-width:680px;box-shadow:0 0 40px rgba(0,0,0,.12);min-height:100vh;background:#f8f4f2}
        }
        @media(min-width:1100px){
          .app-inner{max-width:820px}
        }
        .btn{cursor:pointer;border:none;font-family:'Nunito',sans-serif;transition:all .15s}
        .btn:active{transform:scale(.94)}
        .stap{cursor:pointer;transition:background .1s}.stap:hover{background:rgba(201,128,110,.08)!important}
        .achip{cursor:pointer;transition:filter .15s}.achip:active{filter:brightness(.88)}
        .mov{animation:fi .15s ease}.mbx{animation:su .2s cubic-bezier(.4,0,.2,1)}
        @keyframes fi{from{opacity:0}to{opacity:1}}
        @keyframes su{from{opacity:0;transform:translateY(24px)}to{opacity:1;transform:translateY(0)}}
        .alin{animation:al .25s ease}@keyframes al{from{opacity:0;transform:translateY(-10px)}to{opacity:1;transform:translateY(0)}}
        input:focus,select:focus,textarea:focus{border-color:#c9806e!important;box-shadow:0 0 0 3px rgba(201,128,110,.13);outline:none}
        .ssel{background:rgba(201,128,110,.2)!important}.sst{background:rgba(201,128,110,.4)!important}
        .toast{position:fixed;bottom:24px;left:50%;transform:translateX(-50%);z-index:999;
          background:#2a1a1a;color:#fff;padding:10px 20px;border-radius:20px;
          font-size:13px;font-weight:700;font-family:'Nunito',sans-serif;
          animation:fi .2s ease;white-space:nowrap;box-shadow:0 4px 20px rgba(0,0,0,.3)}
      `}</style>

      {/* TOAST */}
      {toast&&<div className="toast">{toast.msg}</div>}

      {/* TOP BAR */}
      <div style={{background:"#fff",boxShadow:"0 1px 8px rgba(0,0,0,.07)",padding:"0 14px",height:56,display:"flex",alignItems:"center",justifyContent:"space-between",position:"sticky",top:0,zIndex:200}}>
        <div style={{display:"flex",alignItems:"baseline",gap:4}}>
          <span style={{fontFamily:"'Playfair Display',serif",fontSize:22,fontWeight:600}}>Kibele</span>
          <span style={{fontFamily:"'Playfair Display',serif",fontSize:14,fontStyle:"italic",color:C}}>Beauty</span>
        </div>
        <div style={{display:"flex",gap:6,alignItems:"center"}}>
          <button className="btn" onClick={()=>{setShowSrch(s=>!s);setSearch("");}}
            style={{width:36,height:36,borderRadius:"50%",background:showSrch?C:"#f5eded",display:"flex",alignItems:"center",justifyContent:"center",fontSize:15}}>🔍</button>
          <button className="btn" onClick={()=>setShowSett(true)}
            style={{width:36,height:36,borderRadius:"50%",background:"#f5eded",display:"flex",alignItems:"center",justifyContent:"center",fontSize:15}}>⚙️</button>
          <button className="btn" onClick={onLogout}
            style={{width:36,height:36,borderRadius:"50%",background:"#fdf0f0",display:"flex",alignItems:"center",justifyContent:"center",fontSize:15}}>🔒</button>
          <button className="btn" onClick={()=>setModal({type:"add",date:dateStr(selDay),startTime:"09:00",endTime:"10:00"})}
            style={{height:36,padding:"0 13px",borderRadius:18,background:C,color:"#fff",fontSize:13,fontWeight:700}}>+ Randevu</button>
        </div>
      </div>

      {/* SEARCH */}
      {showSrch&&(
        <div className="alin" style={{background:"#fff",borderBottom:"1px solid #ede8e4",padding:"10px 14px"}}>
          <input autoFocus value={search} onChange={e=>setSearch(e.target.value)} placeholder="Müşteri adı veya telefon..."
            style={{width:"100%",padding:"10px 14px",border:"1px solid #e8ddd8",borderRadius:12,fontSize:14,background:"#fdfbfa",fontFamily:"'Nunito',sans-serif",outline:"none"}}/>
          {srchRes.length>0&&(
            <div style={{marginTop:8,maxHeight:260,overflowY:"auto"}}>
              {srchRes.map(a=>{
                const cat=cats.find(c=>c.id===a.categoryId);
                const st=STC[a.status||"pending"];
                return (
                  <div key={a.id} onClick={()=>{setModal({type:"edit",apt:a});setShowSrch(false);setSearch("");}}
                    style={{display:"flex",alignItems:"center",gap:10,padding:"9px 4px",borderBottom:"1px solid #f5ede8",cursor:"pointer"}}>
                    <div style={{width:36,height:36,borderRadius:10,background:cat?.color||C,display:"flex",alignItems:"center",justifyContent:"center",fontSize:16,flexShrink:0}}>{cat?.icon||"📅"}</div>
                    <div style={{flex:1}}>
                      <div style={{fontWeight:700,fontSize:13}}>{a.clientName}</div>
                      <div style={{fontSize:11,color:"#bbb"}}>{a.date} · {a.startTime}{a.endTime?`–${a.endTime}`:""}</div>
                    </div>
                    <div style={{display:"flex",flexDirection:"column",alignItems:"flex-end",gap:2}}>
                      <span style={{fontSize:10,color:st.color,fontWeight:700}}>{st.icon} {st.label}</span>
                      {a.price>0&&<span style={{fontSize:11,color:"#3aaa6e",fontWeight:700}}>{fmtTL(a.price)}</span>}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
          {search.trim().length>=2&&srchRes.length===0&&<div style={{textAlign:"center",color:"#ccc",padding:"14px 0",fontSize:14}}>Sonuç bulunamadı</div>}
        </div>
      )}

      {/* MAIL STATUS */}
      {mailSt&&(
        <div className="alin" style={{padding:"8px 16px",display:"flex",alignItems:"center",gap:10,
          background:mailSt==="ok"?"#edfbf3":mailSt==="error"?"#fdf0f0":"#fffde6",
          borderBottom:`2px solid ${mailSt==="ok"?"#3aaa6e":mailSt==="error"?"#e05555":"#f5c842"}`}}>
          <span style={{fontSize:18}}>{mailSt==="sending"?"⏳":mailSt==="ok"?"✅":"❌"}</span>
          <span style={{fontSize:13,fontWeight:600}}>{mailSt==="sending"?"Gönderiliyor...":mailSt==="ok"?"E-posta gönderildi!":"Gönderilemedi."}</span>
        </div>
      )}

      {/* DAILY ALERT */}
      {alertMsg&&(
        <div className="alin" style={{background:"#f0f4ff",borderBottom:"2px solid #7c9ef5",padding:"10px 16px"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:4}}>
            <span style={{fontSize:13,fontWeight:700,color:"#4060c0"}}>📅 Yarın ({alertMsg.label}) — {alertMsg.list.length} randevu</span>
            <button className="btn" onClick={()=>setAlertMsg(null)} style={{background:"transparent",color:"#aaa",fontSize:20}}>×</button>
          </div>
          {alertMsg.list.map(a=>(
            <div key={a.id} style={{fontSize:12,color:"#5070c0",padding:"2px 0"}}>
              {a.startTime}{a.endTime?`–${a.endTime}`:""} — {a.clientName}{a.price?` · ${fmtTL(a.price)}`:""}
            </div>
          ))}
        </div>
      )}

      {/* SELECTING HINT */}
      {selecting&&(
        <div style={{background:"#fff3f0",borderBottom:"1px solid #f5c0b0",padding:"8px 16px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <span style={{fontSize:13,color:C,fontWeight:700}}>✋ Bitiş saatine dokun — Başlangıç: {selecting.start}</span>
          <button className="btn" onClick={()=>setSelecting(null)} style={{background:"transparent",color:"#bbb",fontSize:22}}>×</button>
        </div>
      )}

      {/* WEEK STRIP */}
      <div style={{background:"#fff",padding:"10px 14px 0",borderBottom:"1px solid #ede8e4",position:"sticky",top:56,zIndex:100}}>
        <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:10}}>
          <button className="btn" onClick={()=>setWeekBase(b=>addDays(b,-7))}
            style={{width:30,height:30,borderRadius:"50%",background:"transparent",border:"1px solid #e8ddd8",fontSize:17,display:"flex",alignItems:"center",justifyContent:"center",color:"#b08080"}}>‹</button>
          <span style={{flex:1,textAlign:"center",fontSize:15,fontWeight:700}}>{TR_M[days[0].getMonth()]} {days[0].getFullYear()}</span>
          <button className="btn" onClick={()=>setWeekBase(b=>addDays(b,7))}
            style={{width:30,height:30,borderRadius:"50%",background:"transparent",border:"1px solid #e8ddd8",fontSize:17,display:"flex",alignItems:"center",justifyContent:"center",color:"#b08080"}}>›</button>
          <button className="btn" onClick={()=>{const t=new Date();setWeekBase(new Date(t.getFullYear(),t.getMonth(),t.getDate()));setSelDay(new Date(t.getFullYear(),t.getMonth(),t.getDate()));setView("day");}}
            style={{padding:"4px 12px",borderRadius:14,background:"#fdf0ee",border:"1px solid #e8c0b0",fontSize:12,color:C,fontWeight:700}}>Bugün</button>
        </div>
        <div style={{display:"flex",gap:2}}>
          {days.map((day,i)=>{
            const isT=sameDay(day,NOW),isSel=view==="day"&&sameDay(day,selDay);
            const dl=dayApts(day);
            const dotC=dl.some(a=>a.status==="pending"||!a.status)?"#f0a030":dl.some(a=>a.status==="done")?"#3aaa6e":dl.length>0?"#e05555":"transparent";
            return (
              <button key={i} className="btn" onClick={()=>{setSelDay(new Date(day.getFullYear(),day.getMonth(),day.getDate()));setView("day");}}
                style={{flex:1,padding:"5px 2px 7px",borderRadius:"10px 10px 0 0",background:isSel?C:"transparent",border:"none",display:"flex",flexDirection:"column",alignItems:"center",gap:3}}>
                <span style={{fontSize:10,color:isSel?"#fff":isT?C:"#aaa",fontWeight:700}}>{TR_S[i]}</span>
                <span style={{width:28,height:28,borderRadius:"50%",background:isSel?"rgba(255,255,255,.25)":isT?C:"transparent",color:isSel||isT?"#fff":"#2a1a1a",fontSize:14,fontWeight:isT?700:400,display:"flex",alignItems:"center",justifyContent:"center"}}>{day.getDate()}</span>
                <span style={{width:5,height:5,borderRadius:"50%",background:isSel?"#fff":dotC}}/>
              </button>
            );
          })}
        </div>
      </div>

      {/* VIEW TOGGLE */}
      <div style={{display:"flex",gap:6,padding:"10px 14px 0"}}>
        {[["week","📆 Hafta"],["day","📅 Gün"],["customers","👥 Müşteri"],["report","📊 Rapor"]].map(([v,l])=>(
          <button key={v} className="btn" onClick={()=>setView(v)}
            style={{flex:1,padding:"8px 2px",borderRadius:10,background:view===v?C:"#fff",color:view===v?"#fff":"#b08080",fontSize:11,fontWeight:700,border:"1px solid #e8ddd8"}}>{l}</button>
        ))}
      </div>

      {view==="week"     &&<WeekView days={days} apts={apts} cats={cats} today={NOW} onDay={d=>{setSelDay(new Date(d.getFullYear(),d.getMonth(),d.getDate()));setView("day");}}/>}
      {view==="day"      &&<DayView day={selDay} today={NOW} apts={dayApts(selDay)} cats={cats} onSlot={handleSlot} selecting={selecting} inSel={inSel} onEdit={apt=>setModal({type:"edit",apt})}/>}
      {view==="customers"&&<CustomersView apts={apts} cats={cats} onApt={apt=>setModal({type:"edit",apt})}/>}
      {view==="report"   &&<ReportsView apts={apts} cats={cats}/>}

      {(modal?.type==="add"||modal?.type==="edit")&&
        <AptModal modal={modal} cats={cats} allApts={apts} staff={staff||[]} onSave={saveApt} onDel={delApt} onClose={()=>setModal(null)}/>}
      {modal?.type==="category"&&
        <CatModal cats={cats} onAdd={saveCat} onDel={delCat} onClose={()=>setModal(null)}/>}
      {modal?.type==="staff"&&
        <StaffModal staff={staff||[]} onAdd={s=>{const ns=[...(staff||[]),s];setStaff(ns);localStorage.setItem("kib_staff_v7",JSON.stringify(ns));}} onDel={id=>{const ns=(staff||[]).filter(x=>x.id!==id);setStaff(ns);localStorage.setItem("kib_staff_v7",JSON.stringify(ns));}} onClose={()=>setModal(null)}/>}
      {modal?.type==="changepw"&&
        <ChangePwModal onClose={()=>setModal(null)}/>}
      {showSett&&
        <SettingsModal sett={sett} onSave={saveSett} onClose={()=>setShowSett(false)} onTest={testEmail} mailSt={mailSt}
          onCat={()=>{setShowSett(false);setModal({type:"category"});}}
          onStaff={()=>{setShowSett(false);setModal({type:"staff"});}}
          onPw={()=>{setShowSett(false);setModal({type:"changepw"});}}/>}
      </div>
    </div>
  );
}

/* ══ WEEK VIEW ══ */
function WeekView({days,apts,cats,today,onDay}){
  return (
    <div style={{padding:"12px 14px 90px"}}>
      {days.map((day,i)=>{
        const ds=dateStr(day);
        const list=apts.filter(a=>a.date===ds).sort((a,b)=>toMins(a.startTime)-toMins(b.startTime));
        const isT=sameDay(day,today);
        const rev=list.filter(a=>a.status==="done"&&a.price>0).reduce((s,a)=>s+Number(a.price),0);
        return (
          <div key={ds} onClick={()=>onDay(day)} style={{background:"#fff",borderRadius:14,padding:"12px 16px",marginBottom:10,cursor:"pointer",boxShadow:isT?"0 0 0 2px #c9806e,0 2px 12px rgba(201,128,110,.12)":"0 1px 6px rgba(0,0,0,.05)"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:list.length?8:0}}>
              <span style={{fontWeight:700,fontSize:14}}>{TR_F[i]} <span style={{color:"#b08080",fontWeight:400}}>{day.getDate()} {TR_M[day.getMonth()]}</span></span>
              <div style={{display:"flex",gap:8,alignItems:"center"}}>
                {rev>0&&<span style={{fontSize:11,color:"#3aaa6e",fontWeight:700}}>{fmtTL(rev)}</span>}
                {isT&&<span style={{fontSize:11,background:"#c9806e",color:"#fff",padding:"2px 8px",borderRadius:10,fontWeight:700}}>Bugün</span>}
                {!isT&&list.length>0&&<span style={{fontSize:12,color:"#c9806e",fontWeight:700}}>{list.length} randevu</span>}
              </div>
            </div>
            {list.map(a=>{const cat=cats.find(c=>c.id===a.categoryId);const st=STC[a.status||"pending"];return(
              <div key={a.id} style={{display:"flex",alignItems:"center",gap:8,padding:"5px 0",borderTop:"1px solid #f5ede8"}}>
                <span style={{fontSize:11,color:"#bbb",width:52,flexShrink:0}}>{a.startTime}{a.endTime?`–${a.endTime}`:""}</span>
                <span style={{width:8,height:8,borderRadius:"50%",background:cat?.color||"#c9806e",flexShrink:0}}/>
                <span style={{fontSize:13,fontWeight:600,flex:1}}>{a.clientName}</span>
                <span style={{fontSize:11}}>{st.icon}</span>
                {a.price>0&&<span style={{fontSize:11,color:"#3aaa6e",fontWeight:700}}>{fmtTL(a.price)}</span>}
              </div>
            );})}
            {list.length===0&&<div style={{fontSize:13,color:"#ddd"}}>Randevu yok</div>}
          </div>
        );
      })}
    </div>
  );
}

/* ══ DAY VIEW ══ */
function DayView({day,today,apts,cats,onSlot,selecting,inSel,onEdit}){
  const ds=dateStr(day),isT=sameDay(day,today),di=(day.getDay()+6)%7;
  const totH=SLOTS.length*SLOT_H;
  const rev=apts.filter(a=>a.status==="done"&&a.price>0).reduce((s,a)=>s+Number(a.price),0);
  return (
    <div style={{paddingBottom:90}}>
      <div style={{padding:"10px 14px 6px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <span style={{fontSize:14,color:"#b08080",fontWeight:600}}>{isT?"Bugün — ":""}{day.getDate()} {TR_M[day.getMonth()]}{!isT&&<span style={{color:"#ccc",fontWeight:400}}> {TR_F[di]}</span>}</span>
        <div style={{display:"flex",alignItems:"center",gap:8}}>
          {rev>0&&<span style={{fontSize:13,color:"#3aaa6e",fontWeight:700}}>Gelir: {fmtTL(rev)}</span>}
          <span style={{fontSize:11,color:"#ccc"}}>Slota dokun</span>
        </div>
      </div>
      <div style={{display:"flex",background:"#fff",borderTop:"1px solid #ede8e4"}}>
        <div style={{width:54,flexShrink:0,position:"relative",height:totH,borderRight:"1px solid #f0ebe8"}}>
          {SLOTS.map((slot,i)=>{const half=slot.endsWith(":30");return(
            <div key={slot} style={{position:"absolute",top:i*SLOT_H,left:0,right:0,height:SLOT_H,borderBottom:`1px solid ${half?"#f8f3f1":"#ede8e4"}`,display:"flex",alignItems:"flex-start",justifyContent:"center",paddingTop:6}}>
              {!half&&<span style={{fontSize:11,color:"#c8b8b0",fontWeight:600}}>{slot}</span>}
            </div>
          );})}
        </div>
        <div style={{flex:1,position:"relative",height:totH}}>
          {SLOTS.map((slot,i)=>{
            const half=slot.endsWith(":30");
            const occ=apts.some(a=>{const s=toMins(a.startTime),e=a.endTime?toMins(a.endTime):s+30;return toMins(slot)>=s&&toMins(slot)<e;});
            const inS=selecting&&selecting.date===ds&&toMins(slot)>=toMins(selecting.start);
            const isStart=selecting?.date===ds&&selecting.start===slot;
            return(
              <div key={slot} className={!occ?(isStart?"sst":inS?"ssel":"stap"):""}
                onClick={()=>!occ&&onSlot(day,slot)}
                style={{position:"absolute",top:i*SLOT_H,left:0,right:0,height:SLOT_H,borderBottom:`1px solid ${half?"#f8f3f1":"#ede8e4"}`,cursor:occ?"default":"pointer"}}/>
            );
          })}
          {(()=>{
            // Çakışan randevuları grupla, yan yana göster
            const placed=apts.map(apt=>{
              const s=toMins(apt.startTime), e=apt.endTime?toMins(apt.endTime):s+30;
              return {...apt,_s:s,_e:e};
            }).sort((a,b)=>a._s-b._s);

            // Her randevu için kaçıncı kolonda olduğunu hesapla
            const cols=[];
            placed.forEach(apt=>{
              let col=0;
              while(cols[col]&&cols[col]._e>apt._s) col++;
              cols[col]=apt;
              apt._col=col;
            });
            const totalCols=cols.length||1;

            return placed.map(apt=>{
              const cat=cats.find(c=>c.id===apt.categoryId);
              const {top,height}=geo(apt.startTime,apt.endTime);
              const dur=apt.endTime?toMins(apt.endTime)-toMins(apt.startTime):30;
              const short=dur<=30;
              const st=STC[apt.status||"pending"];
              const colW=100/totalCols;
              const leftPct=apt._col*colW;
              return(
                <div key={apt.id} className="achip" onClick={()=>onEdit(apt)}
                  style={{position:"absolute",top:top+2,
                    left:`calc(${leftPct}% + 4px)`,
                    width:`calc(${colW}% - 8px)`,
                    height:height-4,
                    background:apt.status==="cancelled"?"#f8f0f0":apt.status==="done"?"#f0fbf5":(cat?.color||"#c9806e"),
                    borderRadius:12,padding:short?"5px 8px":"10px 12px",
                    color:apt.status==="cancelled"||apt.status==="done"?"#2a1a1a":"#fff",
                    boxShadow:"0 3px 12px rgba(0,0,0,.13)",borderLeft:`4px solid ${st.color}`,
                    display:"flex",flexDirection:"column",justifyContent:"space-between",
                    overflow:"hidden",zIndex:10}}>
                  <div>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                      <div style={{fontWeight:700,fontSize:short?12:14,overflow:"hidden",whiteSpace:"nowrap",textOverflow:"ellipsis"}}>{apt.clientName}</div>
                      <span style={{fontSize:10,fontWeight:700,color:st.color,flexShrink:0,marginLeft:2}}>{st.icon}</span>
                    </div>
                    <div style={{fontSize:10,opacity:.8,marginTop:2,overflow:"hidden",whiteSpace:"nowrap",textOverflow:"ellipsis"}}>{apt.startTime}{apt.endTime?` – ${apt.endTime}`:""} · {(apt.categoryIds||[apt.categoryId]).map(id=>cats.find(c=>c.id===id)?.icon||"").join(" ")}</div>
                  </div>
                  {!short&&apt.price>0&&<div style={{fontSize:11,fontWeight:700,color:apt.status==="done"?"#3aaa6e":"rgba(255,255,255,.9)"}}>{fmtTL(apt.price)}</div>}
                  {!short&&apt.note&&totalCols===1&&<div style={{fontSize:10,opacity:.75,fontStyle:"italic",overflow:"hidden",whiteSpace:"nowrap",textOverflow:"ellipsis"}}>"{apt.note}"</div>}
                </div>
              );
            });
          })()}
        </div>
      </div>
    </div>
  );
}

/* ══ CUSTOMERS VIEW ══ */
function CustomersView({apts,cats,onApt}){
  const [sort,setSort]=useState("visits");
  const map={};
  apts.forEach(a=>{if(!a.clientName)return;const k=a.clientName.trim().toLowerCase();if(!map[k])map[k]={name:a.clientName.trim(),apts:[]};map[k].apts.push(a);});
  let clients=Object.values(map).map(c=>{
    const done=c.apts.filter(a=>a.status==="done");
    const rev=done.reduce((s,a)=>s+(isNaN(Number(a.price))?0:Number(a.price)),0);
    const last=c.apts.map(a=>a.date).sort().reverse()[0]||"";
    return {...c,visits:c.apts.length,doneCount:done.length,rev,last};
  });
  if(sort==="visits") clients.sort((a,b)=>b.visits-a.visits);
  else if(sort==="revenue") clients.sort((a,b)=>b.rev-a.rev);
  else clients.sort((a,b)=>b.last.localeCompare(a.last));
  const C="#c9806e";
  const AVC=["#c9806e","#9b6ea8","#6e9bc9","#6ec97a","#c9b46e"];
  return (
    <div style={{padding:"12px 14px 90px"}}>
      <div style={{display:"flex",gap:6,marginBottom:12}}>
        {[["visits","Çok Gelen"],["revenue","Yüksek Gelir"],["recent","Son Gelen"]].map(([k,l])=>(
          <button key={k} className="btn" onClick={()=>setSort(k)}
            style={{flex:1,padding:"7px 4px",borderRadius:10,background:sort===k?C:"#fff",color:sort===k?"#fff":"#b08080",fontSize:11,fontWeight:700,border:"1px solid #e8ddd8"}}>{l}</button>
        ))}
      </div>
      {clients.length===0&&<div style={{textAlign:"center",color:"#ccc",padding:"40px 0",fontSize:14}}>Henüz müşteri yok</div>}
      {clients.map(cl=>{
        const ini=cl.name.split(" ").map(w=>w[0]||"").join("").toUpperCase().slice(0,2);
        const ac=AVC[cl.name.charCodeAt(0)%AVC.length];
        const [ly,lm,ld]=cl.last?cl.last.split("-").map(Number):[0,0,0];
        return(
          <div key={cl.name} style={{background:"#fff",borderRadius:14,padding:"14px 16px",marginBottom:10,boxShadow:"0 1px 6px rgba(0,0,0,.05)"}}>
            <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:10}}>
              <div style={{width:44,height:44,borderRadius:"50%",background:ac,display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontWeight:700,fontSize:16,flexShrink:0}}>{ini}</div>
              <div style={{flex:1}}>
                <div style={{fontWeight:700,fontSize:15}}>{cl.name}</div>
                <div style={{fontSize:12,color:"#bbb",marginTop:2}}>Son: {ld?`${ld} ${TR_M[lm-1]} ${ly}`:"—"}</div>
              </div>
              <div style={{textAlign:"right"}}>
                <div style={{fontWeight:700,fontSize:18,color:C}}>{cl.visits}</div>
                <div style={{fontSize:10,color:"#bbb",fontWeight:600}}>randevu</div>
              </div>
            </div>
            <div style={{display:"flex",gap:8,marginBottom:8}}>
              <div style={{flex:1,background:"#f8f4f2",borderRadius:10,padding:"8px",textAlign:"center"}}>
                <div style={{fontSize:13,fontWeight:700,color:"#3aaa6e"}}>{cl.doneCount}</div>
                <div style={{fontSize:10,color:"#bbb",fontWeight:600}}>Tamamlandı</div>
              </div>
              {cl.rev>0&&<div style={{flex:1,background:"#edfbf3",borderRadius:10,padding:"8px",textAlign:"center"}}>
                <div style={{fontSize:13,fontWeight:700,color:"#3aaa6e"}}>{fmtTL(cl.rev)}</div>
                <div style={{fontSize:10,color:"#bbb",fontWeight:600}}>Toplam</div>
              </div>}
              <div style={{flex:1,background:"#f8f4f2",borderRadius:10,padding:"8px",textAlign:"center"}}>
                <div style={{fontSize:13,fontWeight:700,color:"#9b6ea8"}}>{cl.apts.filter(a=>a.status==="cancelled").length}</div>
                <div style={{fontSize:10,color:"#bbb",fontWeight:600}}>İptal</div>
              </div>
            </div>
            {cl.apts.sort((a,b)=>b.date.localeCompare(a.date)).slice(0,3).map(a=>{
              const cat=cats.find(c=>c.id===a.categoryId);const st=STC[a.status||"pending"];
              const [y,m,d]=a.date.split("-").map(Number);
              return(
                <div key={a.id} onClick={()=>onApt(a)} style={{display:"flex",alignItems:"center",gap:8,padding:"6px 0",borderTop:"1px solid #f5ede8",cursor:"pointer"}}>
                  <span style={{fontSize:15}}>{cat?.icon||"📅"}</span>
                  <div style={{flex:1}}>
                    <div style={{fontSize:12,fontWeight:600}}>{d} {TR_M[m-1]} · {a.startTime}{a.endTime?`–${a.endTime}`:""}</div>
                    <div style={{fontSize:11,color:"#bbb"}}>{cat?.name||""}</div>
                  </div>
                  <div style={{textAlign:"right"}}>
                    <div style={{fontSize:10,color:st.color,fontWeight:700}}>{st.icon} {st.label}</div>
                    {a.price>0&&<div style={{fontSize:11,color:"#3aaa6e",fontWeight:700}}>{fmtTL(a.price)}</div>}
                  </div>
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
}

/* ══ REPORTS VIEW ══ */
function ReportsView({apts,cats}){
  const NOW=new Date();
  const [yr,setYr]=useState(NOW.getFullYear());
  const [mo,setMo]=useState(NOW.getMonth());
  const prevM=()=>mo===0?(setMo(11),setYr(y=>y-1)):setMo(m=>m-1);
  const nextM=()=>mo===11?(setMo(0),setYr(y=>y+1)):setMo(m=>m+1);
  const mApts=apts.filter(a=>{if(!a.date)return false;const[y,m]=a.date.split("-").map(Number);return y===yr&&m-1===mo;});
  const done=mApts.filter(a=>a.status==="done");
  const rev=done.reduce((s,a)=>s+(isNaN(Number(a.price))?0:Number(a.price)),0);
  const mins=mApts.filter(a=>a.status!=="cancelled").reduce((acc,a)=>{if(!a.startTime||!a.endTime)return acc+60;return acc+Math.max(toMins(a.endTime)-toMins(a.startTime),0);},0);
  const catC=cats.map(cat=>({...cat,count:mApts.filter(a=>a.categoryId===cat.id).length,rev:mApts.filter(a=>a.categoryId===cat.id&&a.status==="done").reduce((s,a)=>s+(isNaN(Number(a.price))?0:Number(a.price)),0)})).filter(c=>c.count>0).sort((a,b)=>b.count-a.count);
  const dim=new Date(yr,mo+1,0).getDate();
  const dayC=Array.from({length:dim},(_,i)=>{const ds=`${yr}-${String(mo+1).padStart(2,"0")}-${String(i+1).padStart(2,"0")}`;const dl=mApts.filter(a=>a.date===ds);return{day:i+1,count:dl.length,rev:dl.filter(a=>a.status==="done").reduce((s,a)=>s+(isNaN(Number(a.price))?0:Number(a.price)),0)};});
  const maxD=Math.max(...dayC.map(d=>d.count),1);
  const busiest=dayC.reduce((a,b)=>b.count>a.count?b:a,dayC[0]);
  const weekR=Array.from({length:5},(_,wi)=>{const wl=mApts.filter(a=>{const d=parseInt(a.date.split("-")[2]);return d>=wi*7+1&&d<=(wi+1)*7;});return{w:wi+1,count:wl.length,rev:wl.filter(a=>a.status==="done").reduce((s,a)=>s+(isNaN(Number(a.price))?0:Number(a.price)),0)};}).filter(w=>w.count>0);
  const C="#c9806e";
  const card={background:"#fff",borderRadius:16,padding:16,marginBottom:12,boxShadow:"0 1px 8px rgba(0,0,0,.06)"};
  return (
    <div style={{padding:"12px 14px 90px"}}>
      <div style={{...card,display:"flex",alignItems:"center",gap:10,padding:"12px 16px"}}>
        <button onClick={prevM} style={{width:34,height:34,borderRadius:"50%",background:"#f5eded",border:"none",fontSize:18,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",color:C}}>‹</button>
        <span style={{flex:1,textAlign:"center",fontSize:17,fontWeight:700,fontFamily:"'Playfair Display',serif"}}>{TR_M[mo]} {yr}</span>
        <button onClick={nextM} style={{width:34,height:34,borderRadius:"50%",background:"#f5eded",border:"none",fontSize:18,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",color:C}}>›</button>
      </div>
      <div style={{...card,background:"linear-gradient(135deg,#c9806e,#e8a898)",padding:"20px"}}>
        <div style={{fontSize:12,color:"rgba(255,255,255,.8)",fontWeight:700,letterSpacing:.8,textTransform:"uppercase",marginBottom:4}}>Aylık Toplam Gelir</div>
        <div style={{fontSize:34,fontWeight:700,color:"#fff",fontFamily:"'Playfair Display',serif"}}>{rev>0?fmtTL(rev):"—"}</div>
        <div style={{fontSize:12,color:"rgba(255,255,255,.75)",marginTop:6}}>{done.length} tamamlanan · {mApts.filter(a=>a.status==="cancelled").length} iptal</div>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:12}}>
        {[{l:"Toplam Randevu",v:mApts.length,i:"📅",c:C},{l:"Tamamlanan",v:done.length,i:"✅",c:"#3aaa6e"},{l:"Çalışma Saati",v:`${Math.floor(mins/60)}s${mins%60>0?" "+mins%60+"dk":""}`,i:"⏱",c:"#9b6ea8"},{l:"En Yoğun Gün",v:busiest?.count>0?`${busiest.day} ${TR_M[mo].slice(0,3)} (${busiest.count})`:"—",i:"🔥",c:"#e07050"}].map((x,i)=>(
          <div key={i} style={{background:"#fff",borderRadius:14,padding:14,boxShadow:"0 1px 8px rgba(0,0,0,.06)"}}>
            <div style={{fontSize:20,marginBottom:6}}>{x.i}</div>
            <div style={{fontSize:17,fontWeight:700,color:x.c}}>{x.v}</div>
            <div style={{fontSize:11,color:"#bbb",marginTop:2,fontWeight:600}}>{x.l}</div>
          </div>
        ))}
      </div>
      {weekR.length>0&&<div style={card}>
        <div style={{fontSize:13,fontWeight:700,color:"#888",marginBottom:12,textTransform:"uppercase",letterSpacing:.8}}>Haftalık Dağılım</div>
        {weekR.map(w=>(
          <div key={w.w} style={{display:"flex",alignItems:"center",gap:12,marginBottom:10}}>
            <div style={{width:56,fontSize:12,color:"#bbb",fontWeight:600,flexShrink:0}}>{w.w}. hafta</div>
            <div style={{flex:1,height:8,background:"#f5ede8",borderRadius:4,overflow:"hidden"}}>
              <div style={{height:"100%",width:`${Math.round((w.count/Math.max(...weekR.map(x=>x.count),1))*100)}%`,background:C,borderRadius:4}}/>
            </div>
            <div style={{textAlign:"right",flexShrink:0}}>
              <div style={{fontSize:12,fontWeight:700}}>{w.count}</div>
              {w.rev>0&&<div style={{fontSize:11,color:"#3aaa6e",fontWeight:700}}>{fmtTL(w.rev)}</div>}
            </div>
          </div>
        ))}
      </div>}
      <div style={card}>
        <div style={{fontSize:13,fontWeight:700,color:"#888",marginBottom:12,textTransform:"uppercase",letterSpacing:.8}}>Hizmet Kategorileri</div>
        {mApts.length===0?<div style={{textAlign:"center",color:"#ccc",padding:"20px 0",fontSize:14}}>Bu ay randevu yok</div>
        :catC.map(cat=>{const pct=Math.round((cat.count/mApts.length)*100);return(
          <div key={cat.id} style={{marginBottom:14}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:5}}>
              <div style={{display:"flex",alignItems:"center",gap:8}}><span style={{fontSize:18}}>{cat.icon}</span><span style={{fontSize:13,fontWeight:600}}>{cat.name}</span></div>
              <div style={{display:"flex",alignItems:"center",gap:8}}><span style={{fontSize:13,fontWeight:700,color:cat.color}}>{cat.count}</span><span style={{fontSize:11,color:"#bbb"}}>%{pct}</span>{cat.rev>0&&<span style={{fontSize:11,color:"#3aaa6e",fontWeight:700}}>{fmtTL(cat.rev)}</span>}</div>
            </div>
            <div style={{height:8,background:"#f5ede8",borderRadius:4,overflow:"hidden"}}><div style={{height:"100%",width:`${pct}%`,background:cat.color,borderRadius:4,transition:"width .4s"}}/></div>
          </div>
        );})}
      </div>
      <div style={card}>
        <div style={{fontSize:13,fontWeight:700,color:"#888",marginBottom:12,textTransform:"uppercase",letterSpacing:.8}}>Günlük Yoğunluk</div>
        <div style={{display:"flex",flexWrap:"wrap",gap:4}}>
          {dayC.map(({day,count})=>(
            <div key={day} style={{width:36,height:36,borderRadius:8,background:count===0?"#f5ede8":`rgba(201,128,110,${Math.max(.18,count/maxD)})`,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
              <span style={{fontSize:10,fontWeight:600,color:count>0?"#fff":"#ccc"}}>{day}</span>
              {count>0&&<span style={{fontSize:9,color:"#fff",opacity:.85}}>{count}</span>}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

/* ══ APT MODAL ══ */
/* ── Hizmet Dropdown Bileşeni ── */
function CatDropdown({cats,selected,onToggle,lbl,inp}){
  const [open,setOpen]=useState(false);
  const selectedCats=cats.filter(c=>selected.includes(c.id));
  return(
    <div style={{position:"relative"}}>
      <label style={lbl}>Hizmetler (birden fazla seçilebilir)</label>
      {/* Seçim kutusu */}
      <div onClick={()=>setOpen(o=>!o)}
        style={{...inp,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"space-between",userSelect:"none",minHeight:44}}>
        <div style={{display:"flex",flexWrap:"wrap",gap:4,flex:1}}>
          {selectedCats.length===0
            ? <span style={{color:"#bbb"}}>Hizmet seçin...</span>
            : selectedCats.map(cat=>(
                <span key={cat.id} style={{background:cat.color,color:"#fff",borderRadius:12,padding:"2px 8px",fontSize:12,fontWeight:700,display:"flex",alignItems:"center",gap:3}}>
                  {cat.icon} {cat.name.split("&")[0].trim()} ✓
                </span>
              ))
          }
        </div>
        <span style={{color:"#bbb",fontSize:18,marginLeft:8,flexShrink:0}}>{open?"▲":"▼"}</span>
      </div>
      {/* Açılır liste */}
      {open&&(
        <div style={{position:"absolute",top:"100%",left:0,right:0,background:"#fff",border:"1px solid #e8ddd8",borderRadius:12,boxShadow:"0 8px 24px rgba(0,0,0,.12)",zIndex:100,overflow:"hidden",marginTop:4}}>
          {cats.map(cat=>{
            const sel=selected.includes(cat.id);
            return(
              <div key={cat.id} onClick={()=>onToggle(cat.id)}
                style={{display:"flex",alignItems:"center",gap:12,padding:"11px 14px",cursor:"pointer",
                  background:sel?"#fdf0ee":"#fff",borderBottom:"1px solid #f5ede8",transition:"background .1s"}}
                onMouseEnter={e=>!sel&&(e.currentTarget.style.background="#faf7f5")}
                onMouseLeave={e=>!sel&&(e.currentTarget.style.background="#fff")}>
                <div style={{width:20,height:20,borderRadius:6,border:`2px solid ${sel?cat.color:"#e8ddd8"}`,
                  background:sel?cat.color:"transparent",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                  {sel&&<span style={{color:"#fff",fontSize:13,fontWeight:900}}>✓</span>}
                </div>
                <div style={{width:10,height:10,borderRadius:"50%",background:cat.color,flexShrink:0}}/>
                <span style={{fontSize:15}}>{cat.icon}</span>
                <span style={{flex:1,fontSize:14,fontWeight:sel?700:400,color:sel?cat.color:"#2a1a1a"}}>{cat.name}</span>
              </div>
            );
          })}
          <div onClick={()=>setOpen(false)}
            style={{padding:"10px 14px",textAlign:"center",fontSize:13,color:"#c9806e",fontWeight:700,cursor:"pointer",background:"#faf7f5"}}>
            Tamam ✓
          </div>
        </div>
      )}
      {selected.length===0&&<div style={{fontSize:11,color:"#e05555",marginTop:4}}>En az 1 hizmet seçin</div>}
    </div>
  );
}

function AptModal({modal,cats,allApts,staff,onSave,onDel,onClose}){
  const isEdit=modal.type==="edit";
  const C="#c9806e";
  const apt=modal.apt||{};

  const [form,setForm]=useState({
    clientName:   apt.clientName||"",
    phone:        apt.phone||"",
    categoryIds:  apt.categoryIds||(apt.categoryId?[apt.categoryId]:[]),
    date:         apt.date||modal.date||dateStr(new Date()),
    startTime:    apt.startTime||modal.startTime||"09:00",
    endTime:      apt.endTime||modal.endTime||"10:00",
    note:         apt.note||"",
    status:       apt.status||"pending",
    price:        apt.price||"",
    staffId:      apt.staffId||"",
    paymentType:  apt.paymentType||"",
  });
  const set=(k,v)=>setForm(f=>({...f,[k]:v}));

  // Çoklu kategori toggle
  const toggleCat=(id)=>{
    setForm(f=>{
      const ids=f.categoryIds.includes(id)?f.categoryIds.filter(x=>x!==id):[...f.categoryIds,id];
      return {...f,categoryIds:ids};
    });
  };

  const dur=toMins(form.endTime)-toMins(form.startTime);

  // Müşteri otomatik tamamlama
  const [showSugg,setShowSugg]=useState(false);
  const suggestions=form.clientName.trim().length>=2
    ? [...new Map(allApts.filter(a=>a.clientName?.toLowerCase().startsWith(form.clientName.trim().toLowerCase())&&a.clientName.trim().toLowerCase()!==form.clientName.trim().toLowerCase()).map(a=>[a.clientName.trim().toLowerCase(),a])).values()].slice(0,4)
    : [];

  const pickSuggestion=(a)=>{
    setForm(f=>({...f,clientName:a.clientName,phone:a.phone||f.phone}));
    setShowSugg(false);
  };

  // Önceki randevular
  const hist=form.clientName.trim().length>1
    ? allApts.filter(a=>a.clientName?.toLowerCase()===form.clientName.trim().toLowerCase()&&(!isEdit||a.id!==apt.id))
        .sort((a,b)=>b.date.localeCompare(a.date)).slice(0,3)
    : [];

  const inp={width:"100%",padding:"11px 14px",border:"1px solid #e8ddd8",borderRadius:12,fontSize:14,background:"#fdfbfa",color:"#2a1a1a",marginTop:4,fontFamily:"'Nunito',sans-serif"};
  const lbl={fontSize:11,color:"#b08080",fontWeight:700,letterSpacing:.8,textTransform:"uppercase"};

  const PAYMENT_TYPES=[
    {id:"cash",  label:"Nakit",        icon:"💵"},
    {id:"card",  label:"Kredi Kartı",  icon:"💳"},
    {id:"havale",label:"Havale/EFT",   icon:"🏦"},
  ];

  return(
    <div className="mov" onClick={onClose} style={{position:"fixed",inset:0,background:"rgba(42,26,26,.52)",display:"flex",alignItems:"flex-end",justifyContent:"center",zIndex:300}}>
      <div className="mbx" onClick={e=>e.stopPropagation()} style={{background:"#fff",borderRadius:"22px 22px 0 0",padding:"18px 20px 40px",width:"100%",maxWidth:480,maxHeight:"94vh",overflowY:"auto",boxShadow:"0 -8px 40px rgba(0,0,0,.2)"}}>
        <div style={{width:40,height:4,borderRadius:2,background:"#e8ddd8",margin:"0 auto 18px"}}/>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
          <h2 style={{fontFamily:"'Playfair Display',serif",fontSize:22,fontWeight:600}}>{isEdit?"Düzenle":"Yeni Randevu"}</h2>
          <button className="btn" onClick={onClose} style={{width:34,height:34,borderRadius:"50%",background:"#f5eded",color:"#b08080",fontSize:20,display:"flex",alignItems:"center",justifyContent:"center"}}>×</button>
        </div>

        {/* Durum */}
        <div style={{display:"flex",gap:8,marginBottom:16}}>
          {Object.entries(STC).map(([k,st])=>(
            <button key={k} onClick={()=>set("status",k)} style={{flex:1,padding:"8px 4px",borderRadius:12,fontSize:12,cursor:"pointer",fontFamily:"'Nunito',sans-serif",fontWeight:700,transition:"all .15s",background:form.status===k?st.bg:"#f8f4f2",color:form.status===k?st.color:"#bbb",border:`2px solid ${form.status===k?st.color:"transparent"}`}}>
              {st.icon} {st.label}
            </button>
          ))}
        </div>

        <div style={{display:"flex",flexDirection:"column",gap:13}}>

          {/* Müşteri adı + otomatik tamamlama */}
          <div style={{position:"relative"}}>
            <label style={lbl}>Müşteri Adı *</label>
            <input style={inp} value={form.clientName}
              onChange={e=>{set("clientName",e.target.value);setShowSugg(true);}}
              onBlur={()=>setTimeout(()=>setShowSugg(false),200)}
              onFocus={()=>setShowSugg(true)}
              placeholder="Ad Soyad"/>
            {showSugg&&suggestions.length>0&&(
              <div style={{position:"absolute",top:"100%",left:0,right:0,background:"#fff",border:"1px solid #e8ddd8",borderRadius:12,boxShadow:"0 8px 24px rgba(0,0,0,.12)",zIndex:50,overflow:"hidden"}}>
                {suggestions.map(a=>(
                  <div key={a.id} onMouseDown={()=>pickSuggestion(a)}
                    style={{padding:"10px 14px",cursor:"pointer",display:"flex",alignItems:"center",gap:10,borderBottom:"1px solid #f5ede8"}}
                    onMouseEnter={e=>e.currentTarget.style.background="#fdf0ee"}
                    onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                    <div style={{width:32,height:32,borderRadius:"50%",background:"#c9806e",color:"#fff",display:"flex",alignItems:"center",justifyContent:"center",fontWeight:700,fontSize:13,flexShrink:0}}>
                      {a.clientName.charAt(0).toUpperCase()}
                    </div>
                    <div>
                      <div style={{fontWeight:700,fontSize:13}}>{a.clientName}</div>
                      {a.phone&&<div style={{fontSize:11,color:"#bbb"}}>{a.phone}</div>}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Önceki randevular */}
          {hist.length>0&&(
            <div style={{background:"#f0f4ff",borderRadius:10,padding:"8px 12px",fontSize:12,color:"#4060c0"}}>
              <div style={{fontWeight:700,marginBottom:4}}>📋 Önceki randevular</div>
              {hist.map(a=>{
                const catNames=(a.categoryIds||[a.categoryId]).map(id=>cats.find(c=>c.id===id)?.icon||"").join(" ");
                const st=STC[a.status||"pending"];
                const[y,m,d]=a.date.split("-").map(Number);
                return(<div key={a.id} style={{display:"flex",justifyContent:"space-between",padding:"2px 0"}}>
                  <span>{d} {TR_M[m-1]} · {catNames}</span>
                  <span style={{color:st.color,fontWeight:700}}>{st.icon} {a.price?fmtTL(a.price):""}</span>
                </div>);
              })}
            </div>
          )}

          <div><label style={lbl}>Telefon</label><input style={inp} value={form.phone} onChange={e=>set("phone",e.target.value)} placeholder="05XX XXX XX XX" inputMode="tel"/></div>

          {/* Çoklu hizmet seçimi - dropdown */}
          <CatDropdown cats={cats} selected={form.categoryIds} onToggle={toggleCat} lbl={lbl} inp={inp}/>

          {/* Personel */}
          {(staff||[]).length>0&&(
            <div>
              <label style={lbl}>Personel</label>
              <select style={inp} value={form.staffId} onChange={e=>set("staffId",e.target.value)}>
                <option value="">Seçiniz...</option>
                {(staff||[]).map(s=><option key={s.id} value={s.id}>{s.name}</option>)}
              </select>
            </div>
          )}

          <div><label style={lbl}>Tarih</label><input type="date" style={inp} value={form.date} onChange={e=>set("date",e.target.value)}/></div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
            <div><label style={lbl}>Başlangıç</label>
              <select style={inp} value={form.startTime} onChange={e=>set("startTime",e.target.value)}>
                {SLOTS.map(t=><option key={t} value={t}>{t}</option>)}
              </select>
            </div>
            <div><label style={lbl}>Bitiş</label>
              <select style={inp} value={form.endTime} onChange={e=>set("endTime",e.target.value)}>
                {SLOTS.filter(t=>toMins(t)>toMins(form.startTime)).map(t=><option key={t} value={t}>{t}</option>)}
              </select>
            </div>
          </div>
          {dur>0&&<div style={{textAlign:"center",fontSize:13,color:C,fontWeight:700,background:"#fdf0ee",borderRadius:10,padding:7}}>⏱ {dur} dk{dur>=60?` (${Math.floor(dur/60)} saat${dur%60?` ${dur%60} dk`:""})`:""}  </div>}

          {/* Ücret + Ödeme türü */}
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
            <div><label style={lbl}>Ücret (₺)</label>
              <input style={inp} value={form.price} onChange={e=>set("price",e.target.value.replace(/[^0-9]/g,""))} placeholder="0" inputMode="numeric"/>
            </div>
            <div><label style={lbl}>Ödeme Türü</label>
              <select style={inp} value={form.paymentType} onChange={e=>set("paymentType",e.target.value)}>
                <option value="">Seçiniz</option>
                {PAYMENT_TYPES.map(p=><option key={p.id} value={p.id}>{p.icon} {p.label}</option>)}
              </select>
            </div>
          </div>

          <div><label style={lbl}>Not</label>
            <textarea style={{...inp,resize:"vertical",minHeight:68}} value={form.note} onChange={e=>set("note",e.target.value)} placeholder="İşlem detayı..."/>
          </div>
        </div>

        <div style={{display:"flex",gap:8,marginTop:20}}>
          {isEdit&&<button className="btn" onClick={()=>onDel(apt.id)} style={{width:44,height:44,borderRadius:12,background:"#fdf0f0",color:"#e05555",fontSize:18,display:"flex",alignItems:"center",justifyContent:"center"}}>🗑</button>}
          <button className="btn" onClick={()=>{if(form.clientName.trim()&&form.categoryIds.length>0)onSave({...form,price:form.price?Number(form.price):0});}}
            style={{flex:1,height:44,borderRadius:12,background:(form.clientName.trim()&&form.categoryIds.length>0)?"#c9806e":"#e8d0c8",color:"#fff",fontSize:15,fontWeight:700}}>
            {isEdit?"Güncelle":"Randevu Ekle"}
          </button>
        </div>
      </div>
    </div>
  );
}


/* ══ CAT MODAL ══ */
function CatModal({cats,onAdd,onDel,onClose}){
  const [name,setName]=useState(""); const [icon,setIcon]=useState("💅"); const [color,setColor]=useState("#c9806e");
  const inp={width:"100%",padding:"11px 14px",border:"1px solid #e8ddd8",borderRadius:12,fontSize:14,background:"#fdfbfa",color:"#2a1a1a",marginTop:4,fontFamily:"'Nunito',sans-serif"};
  const add=()=>{if(!name.trim())return;onAdd({id:String(Date.now()),name:name.trim(),icon,color});setName("");};
  return (
    <div className="mov" onClick={onClose} style={{position:"fixed",inset:0,background:"rgba(42,26,26,.52)",display:"flex",alignItems:"flex-end",justifyContent:"center",zIndex:300}}>
      <div className="mbx" onClick={e=>e.stopPropagation()} style={{background:"#fff",borderRadius:"22px 22px 0 0",padding:"18px 20px 40px",width:"100%",maxWidth:480,maxHeight:"85vh",overflowY:"auto"}}>
        <div style={{width:40,height:4,borderRadius:2,background:"#e8ddd8",margin:"0 auto 16px"}}/>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
          <h2 style={{fontFamily:"'Playfair Display',serif",fontSize:22,fontWeight:600}}>Kategoriler</h2>
          <button className="btn" onClick={onClose} style={{width:34,height:34,borderRadius:"50%",background:"#f5eded",color:"#b08080",fontSize:20,display:"flex",alignItems:"center",justifyContent:"center"}}>×</button>
        </div>
        {cats.map(c=>(<div key={c.id} style={{display:"flex",alignItems:"center",gap:10,padding:"10px 14px",borderRadius:12,background:"#faf7f5",marginBottom:8}}>
          <div style={{width:12,height:12,borderRadius:"50%",background:c.color,flexShrink:0}}/><span style={{fontSize:16}}>{c.icon}</span>
          <span style={{flex:1,fontSize:14,fontWeight:600}}>{c.name}</span>
          <button className="btn" onClick={()=>onDel(c.id)} style={{background:"transparent",color:"#e08080",fontSize:22}}>×</button>
        </div>))}
        <div style={{borderTop:"1px solid #ede8e4",paddingTop:16,marginTop:8}}>
          <div style={{fontSize:11,color:"#b08080",fontWeight:700,letterSpacing:.8,marginBottom:10,textTransform:"uppercase"}}>Yeni Kategori</div>
          <input style={inp} value={name} onChange={e=>setName(e.target.value)} placeholder="Kategori adı" onKeyDown={e=>e.key==="Enter"&&add()}/>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginTop:10}}>
            <div><label style={{fontSize:11,color:"#b08080",fontWeight:700}}>İkon</label><input style={{...inp,textAlign:"center",fontSize:20}} value={icon} onChange={e=>setIcon(e.target.value)} maxLength={2}/></div>
            <div><label style={{fontSize:11,color:"#b08080",fontWeight:700}}>Renk</label><input type="color" style={{...inp,height:46,padding:6}} value={color} onChange={e=>setColor(e.target.value)}/></div>
          </div>
          <button className="btn" onClick={add} style={{width:"100%",marginTop:12,padding:13,borderRadius:12,background:"#c9806e",color:"#fff",fontSize:14,fontWeight:700}}>+ Ekle</button>
        </div>
      </div>
    </div>
  );
}

/* ══ STAFF MODAL ══ */
function StaffModal({staff,onAdd,onDel,onClose}){
  const [name,setName]=useState("");
  const [role,setRole]=useState("");
  const C="#c9806e";
  const inp={width:"100%",padding:"11px 14px",border:"1px solid #e8ddd8",borderRadius:12,fontSize:14,background:"#fdfbfa",color:"#2a1a1a",marginTop:4,fontFamily:"'Nunito',sans-serif"};
  const add=()=>{
    if(!name.trim())return;
    onAdd({id:String(Date.now()),name:name.trim(),role:role.trim()});
    setName("");setRole("");
  };
  return(
    <div className="mov" onClick={onClose} style={{position:"fixed",inset:0,background:"rgba(42,26,26,.52)",display:"flex",alignItems:"flex-end",justifyContent:"center",zIndex:300}}>
      <div className="mbx" onClick={e=>e.stopPropagation()} style={{background:"#fff",borderRadius:"22px 22px 0 0",padding:"18px 20px 40px",width:"100%",maxWidth:480,maxHeight:"85vh",overflowY:"auto"}}>
        <div style={{width:40,height:4,borderRadius:2,background:"#e8ddd8",margin:"0 auto 16px"}}/>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
          <h2 style={{fontFamily:"'Playfair Display',serif",fontSize:22,fontWeight:600}}>Personel</h2>
          <button className="btn" onClick={onClose} style={{width:34,height:34,borderRadius:"50%",background:"#f5eded",color:"#b08080",fontSize:20,display:"flex",alignItems:"center",justifyContent:"center"}}>×</button>
        </div>
        {(staff||[]).length===0&&<div style={{textAlign:"center",color:"#ccc",padding:"16px 0",fontSize:14}}>Henüz personel eklenmedi</div>}
        {(staff||[]).map(s=>(
          <div key={s.id} style={{display:"flex",alignItems:"center",gap:10,padding:"10px 14px",borderRadius:12,background:"#faf7f5",marginBottom:8}}>
            <div style={{width:36,height:36,borderRadius:"50%",background:C,color:"#fff",display:"flex",alignItems:"center",justifyContent:"center",fontWeight:700,fontSize:15,flexShrink:0}}>
              {s.name.charAt(0).toUpperCase()}
            </div>
            <div style={{flex:1}}>
              <div style={{fontWeight:700,fontSize:14}}>{s.name}</div>
              {s.role&&<div style={{fontSize:12,color:"#bbb"}}>{s.role}</div>}
            </div>
            <button className="btn" onClick={()=>onDel(s.id)} style={{background:"transparent",color:"#e08080",fontSize:22}}>×</button>
          </div>
        ))}
        <div style={{borderTop:"1px solid #ede8e4",paddingTop:16,marginTop:8}}>
          <div style={{fontSize:11,color:"#b08080",fontWeight:700,letterSpacing:.8,marginBottom:10,textTransform:"uppercase"}}>Yeni Personel Ekle</div>
          <input style={inp} value={name} onChange={e=>setName(e.target.value)} placeholder="Ad Soyad" onKeyDown={e=>e.key==="Enter"&&add()}/>
          <input style={{...inp,marginTop:8}} value={role} onChange={e=>setRole(e.target.value)} placeholder="Görev (örn: Estetisyen)" onKeyDown={e=>e.key==="Enter"&&add()}/>
          <button className="btn" onClick={add} style={{width:"100%",marginTop:12,padding:13,borderRadius:12,background:C,color:"#fff",fontSize:14,fontWeight:700}}>+ Ekle</button>
        </div>
      </div>
    </div>
  );
}

/* ══ CHANGE PW MODAL ══ */
function ChangePwModal({onClose}){
  const C="#c9806e";
  const [cur,setCur]=useState(""); const [nw,setNw]=useState(""); const [conf,setConf]=useState("");
  const [err,setErr]=useState(""); const [ok,setOk]=useState(false); const [busy,setBusy]=useState(false);
  const save=async()=>{
    setErr("");
    if(nw.length<6){setErr("En az 6 karakter olmalı");return;}
    if(nw!==conf){setErr("Şifreler eşleşmiyor");return;}
    setBusy(true);
    const token=localStorage.getItem(SEK);
    const ok=await auth.updatePassword(token,nw);
    setBusy(false);
    if(ok){setOk(true);setTimeout(onClose,1500);}
    else setErr("Şifre güncellenemedi, tekrar deneyin");
  };
  const inp={width:"100%",padding:"11px 14px",border:"1px solid #e8ddd8",borderRadius:12,fontSize:14,background:"#fdfbfa",color:"#2a1a1a",marginTop:4,fontFamily:"'Nunito',sans-serif"};
  const lbl={fontSize:11,color:"#b08080",fontWeight:700,letterSpacing:.8,textTransform:"uppercase"};
  return (
    <div className="mov" onClick={onClose} style={{position:"fixed",inset:0,background:"rgba(42,26,26,.52)",display:"flex",alignItems:"flex-end",justifyContent:"center",zIndex:300}}>
      <div className="mbx" onClick={e=>e.stopPropagation()} style={{background:"#fff",borderRadius:"22px 22px 0 0",padding:"18px 20px 40px",width:"100%",maxWidth:480,boxShadow:"0 -8px 40px rgba(0,0,0,.2)"}}>
        <div style={{width:40,height:4,borderRadius:2,background:"#e8ddd8",margin:"0 auto 18px"}}/>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
          <h2 style={{fontFamily:"'Playfair Display',serif",fontSize:22,fontWeight:600}}>Şifre Değiştir</h2>
          <button className="btn" onClick={onClose} style={{width:34,height:34,borderRadius:"50%",background:"#f5eded",color:"#b08080",fontSize:20,display:"flex",alignItems:"center",justifyContent:"center"}}>×</button>
        </div>
        {ok?(<div style={{textAlign:"center",padding:"20px 0"}}><div style={{fontSize:40,marginBottom:12}}>✅</div><div style={{fontSize:15,fontWeight:700,color:"#3aaa6e"}}>Şifre güncellendi!</div></div>):(
          <div style={{display:"flex",flexDirection:"column",gap:14}}>
            <div style={{fontSize:12,color:"#b08080",background:"#f5f0ee",borderRadius:10,padding:"8px 12px"}}>Supabase hesabınızın şifresini değiştiriyorsunuz.</div>
            <div><label style={lbl}>Yeni Şifre</label><input style={inp} type="password" value={nw} onChange={e=>{setNw(e.target.value);setErr("");}} placeholder="En az 6 karakter"/></div>
            <div><label style={lbl}>Yeni Şifre (Tekrar)</label><input style={inp} type="password" value={conf} onChange={e=>{setConf(e.target.value);setErr("");}} placeholder="••••••••"/></div>
            {err&&<div style={{fontSize:13,color:"#e05555",textAlign:"center",fontWeight:700,background:"#fdf0f0",borderRadius:10,padding:8}}>{err}</div>}
            <button className="btn" onClick={save} disabled={busy} style={{padding:13,borderRadius:12,background:C,color:"#fff",fontSize:14,fontWeight:700,opacity:busy?.6:1}}>{busy?"Güncelleniyor...":"Kaydet"}</button>
          </div>
        )}
      </div>
    </div>
  );
}

/* ══ SETTINGS MODAL ══ */
function SettingsModal({sett,onSave,onClose,onTest,mailSt,onCat,onPw,onStaff}){
  const [f,setF]=useState({...sett});
  const sf=(k,v)=>setF(p=>({...p,[k]:v}));
  const inp={width:"100%",padding:"11px 14px",border:"1px solid #e8ddd8",borderRadius:12,fontSize:14,background:"#fdfbfa",color:"#2a1a1a",marginTop:4,fontFamily:"'Nunito',sans-serif"};
  const lbl={fontSize:11,color:"#b08080",fontWeight:700,letterSpacing:.8,textTransform:"uppercase"};
  const ready=f.svcId&&f.tplId&&f.pubKey&&f.toEmail;
  return (
    <div className="mov" onClick={onClose} style={{position:"fixed",inset:0,background:"rgba(42,26,26,.52)",display:"flex",alignItems:"flex-end",justifyContent:"center",zIndex:300}}>
      <div className="mbx" onClick={e=>e.stopPropagation()} style={{background:"#fff",borderRadius:"22px 22px 0 0",padding:"18px 20px 40px",width:"100%",maxWidth:480,maxHeight:"92vh",overflowY:"auto"}}>
        <div style={{width:40,height:4,borderRadius:2,background:"#e8ddd8",margin:"0 auto 16px"}}/>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
          <h2 style={{fontFamily:"'Playfair Display',serif",fontSize:22,fontWeight:600}}>Ayarlar</h2>
          <button className="btn" onClick={onClose} style={{width:34,height:34,borderRadius:"50%",background:"#f5eded",color:"#b08080",fontSize:20,display:"flex",alignItems:"center",justifyContent:"center"}}>×</button>
        </div>
        <button className="btn" onClick={onCat} style={{width:"100%",padding:"12px",borderRadius:12,background:"#f5eded",color:"#c9806e",fontSize:14,fontWeight:700,marginBottom:8,textAlign:"left"}}>🏷️ Kategorileri Düzenle →</button>
        <button className="btn" onClick={onStaff} style={{width:"100%",padding:"12px",borderRadius:12,background:"#f5eded",color:"#c9806e",fontSize:14,fontWeight:700,marginBottom:8,textAlign:"left"}}>👥 Personel Yönetimi →</button>
        <button className="btn" onClick={onPw}  style={{width:"100%",padding:"12px",borderRadius:12,background:"#f5eded",color:"#c9806e",fontSize:14,fontWeight:700,marginBottom:16,textAlign:"left"}}>🔑 Şifre Değiştir →</button>
        <div style={{fontSize:13,fontWeight:700,color:"#888",marginBottom:10,textTransform:"uppercase",letterSpacing:.8}}>E-posta Bildirimi</div>
        <div style={{background:"#f0f4ff",borderRadius:12,padding:"12px 14px",marginBottom:14,fontSize:12,color:"#4060a0",lineHeight:1.8}}>
          <b>Kurulum:</b> <a href="https://emailjs.com" target="_blank" rel="noreferrer" style={{color:"#4060c0"}}>emailjs.com</a> → ücretsiz hesap → Email Services → Gmail → <b>Service ID</b> · Templates → konu <code style={{background:"#dde8ff",padding:"1px 4px",borderRadius:3}}>{"{{subject}}"}</code> içerik <code style={{background:"#dde8ff",padding:"1px 4px",borderRadius:3}}>{"{{message}}"}</code> to <code style={{background:"#dde8ff",padding:"1px 4px",borderRadius:3}}>{"{{to_email}}"}</code> → <b>Template ID</b> · Account → <b>Public Key</b>
        </div>
        <div style={{display:"flex",flexDirection:"column",gap:12}}>
          <div><label style={lbl}>E-posta</label><input style={inp} value={f.toEmail} onChange={e=>sf("toEmail",e.target.value)} placeholder="salon@gmail.com" inputMode="email"/></div>
          <div><label style={lbl}>Service ID</label><input style={inp} value={f.svcId} onChange={e=>sf("svcId",e.target.value)} placeholder="service_xxxxxxx"/></div>
          <div><label style={lbl}>Template ID</label><input style={inp} value={f.tplId} onChange={e=>sf("tplId",e.target.value)} placeholder="template_xxxxxxx"/></div>
          <div><label style={lbl}>Public Key</label><input style={inp} value={f.pubKey} onChange={e=>sf("pubKey",e.target.value)} placeholder="xxxxxxxxxxxxxxxxxxxx"/></div>
        </div>
        <div style={{background:"#faf7f5",borderRadius:12,padding:"10px 14px",marginTop:14,fontSize:12,color:"#b08080",lineHeight:1.6}}>
          ⏰ Her gün <b style={{color:"#c9806e"}}>akşam 20:00'de</b> ertesi günün randevuları otomatik gönderilir.
        </div>
        <div style={{display:"flex",gap:8,marginTop:18}}>
          {ready&&<button className="btn" onClick={onTest} disabled={mailSt==="sending"} style={{flex:1,height:44,borderRadius:12,background:"#e8f0fe",color:"#4060c0",fontSize:13,fontWeight:700,opacity:mailSt==="sending"?.6:1}}>{mailSt==="sending"?"⏳...":"🧪 Test"}</button>}
          <button className="btn" onClick={()=>onSave(f)} style={{flex:1,height:44,borderRadius:12,background:"#c9806e",color:"#fff",fontSize:14,fontWeight:700}}>Kaydet</button>
        </div>
      </div>
    </div>
  );
}
